var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWellenUnten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1440 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_4219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M933.669 34.4999C1086.22 73.7 1212.01 73.8333 1255.83 69L1414 50.5L1302 -40.5L-358.5 -40.5002L-358.5 93.9998C-210.967 74.4999 -117.128 -3.00013 78.0775 34.4999C282.139 73.7013 316.941 115 496.59 59.4999C616.021 22.6033 781.118 -4.70007 933.669 34.4999Z",
    fill: "#6EADD4",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288 34.5C1440 73.7 1565.33 73.8333 1609 69L1655 59.5L1655 -40.5L0.500012 -40.5001L0.5 93.9999C147.5 74.4999 241 -3.00012 435.5 34.4999C638.824 73.7013 673.5 115 852.5 59.4999C971.5 22.6033 1136 -4.70006 1288 34.5Z",
    fill: "#DC7545",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124 35C1276 74.2 1401.33 74.3333 1445 69.5L1491 6L1491 -40L-163.5 -40.0001L-163.5 94.4999C-16.5 74.9999 77 -2.50012 271.5 34.9999C474.824 74.2013 509.5 115.5 688.5 59.9999C807.5 23.1033 972 -4.20006 1124 35Z",
    fill: "#FFFCF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_4219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 171,
    fill: "white",
    transform: "translate(1440 171) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellenUnten);
export default __webpack_public_path__ + "static/media/wellen_unten.3ec302e7c90abe8f66d478b05d8034e3.svg";
export { ForwardRef as ReactComponent };